import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  blockOtpRequest: false,
  otpSent: false,
  otpRequestKey: 0,
  auth: false,
  authnum: '',
  updatePwd: false,
  updatePwdError: false,
  incorrectOTPcount: 0,
  passwordResult: {},
  error: {
    otp: '',
  },
};

const passwordChangeForPPPSlice = createSlice({
  name: 'passwordChangeForPPP',
  initialState,
  reducers: {
    initPasswordChangeForPPP: () => initialState,
    getAuthenticateCallPhone: () => {},
    getAuthenticateExternalMail: () => {},
    setRequestOtpState: (state, { payload }) => {
      state.blockOtpRequest = !payload;
      if (!payload) state.otpRequestKey += 1;
    },
    setOtpSent: (state, { payload }) => {
      state.otpSent = payload;
    },
    getAuthenticateAuthNum: (state, { payload }) => {
      state.authnum = payload.authnum;
    },
    getAuthenticateAuthNumSuccess: state => {
      state.auth = true;
      state.error.otp = '';
    },
    completeContactRegistrationAuth: (state, { payload }) => {
      state.auth = true;
      state.authnum = payload;
      state.error.otp = '';
    },
    setAuthenticateAuthNumFail: (state, { payload }) => {
      state.error.otp = payload;
      state.incorrectOTPcount += 1;
    },
    resetIncorrectOTPCount: state => {
      state.incorrectOTPcount = 0;
      state.error.otp = '';
    },
    resetAuthentication: state => {
      state.blockOtpRequest = false;
      state.otpSent = false;
      state.auth = false;
      state.authnum = '';
      state.incorrectOTPcount = 0;
      state.error.otp = '';
    },
    modifyPassword: state => {
      state.updatePwd = false;
      state.updatePwdError = false;
      state.passwordResult = {};
    },
    modifyPasswordSuccess: (state, { payload }) => {
      state.updatePwd = typeof payload === 'boolean' ? payload : payload.result ?? true;
      state.updatePwdError = false;
      state.passwordResult = typeof payload === 'boolean' ? {} : payload;
    },
    modifyPasswordFail: state => {
      state.updatePwdError = true;
    },
  },
});

export const {
  initPasswordChangeForPPP,
  getAuthenticateCallPhone,
  getAuthenticateExternalMail,
  setRequestOtpState,
  setOtpSent,
  getAuthenticateAuthNum,
  getAuthenticateAuthNumSuccess,
  completeContactRegistrationAuth,
  setAuthenticateAuthNumFail,
  resetIncorrectOTPCount,
  resetAuthentication,
  modifyPassword,
  modifyPasswordSuccess,
  modifyPasswordFail,
} = passwordChangeForPPPSlice.actions;

export default passwordChangeForPPPSlice.reducer;
